import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "components__competencies-overview" }

import { computed } from "vue";
  import CompetencyAccordion from "vue/applications/frontend/components/competency-accordion.vue"
  import { useStore } from "vuex";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'competencies-overview',
  setup(__props) {

  const store = useStore();
  
  const competencies = computed(() => store.state.gon.competencies)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competencies.value, (competency) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "competency",
        key: competency.id
      }, [
        _createVNode(CompetencyAccordion, { competency: competency }, null, 8, ["competency"])
      ]))
    }), 128))
  ]))
}
}

})